import { keymap } from 'prosemirror-keymap';
import type { EditorView } from 'prosemirror-view';

import type { StrikethroughSchema } from './strikethrough-mark';
import type {
  EditorButton,
  EditorMode,
  ProsemirrorCommand,
  RtPMPlugin,
} from '../../../editor/types';
import { MarkService } from '../../../helpers/mark-base';
import { DEFAULT_KEYMAP_INPUTRULE_PRIORITY } from '../../../helpers/utils';

export class StrikethroughService<S extends StrikethroughSchema> extends MarkService<S> {}

export class StrikethroughPlugin implements RtPMPlugin {
  public buttons = {
    toggleStrikethrough: <EditorButton>{
      icon: 'format-strikethrough',
      isActive: (...args) => this.strikethroughService.isActive(...args),
      run: (state, dispatch) => {
        this.strikethroughService.toggle(state, dispatch);
      },
    },
  };

  private editorView: EditorView;
  private strikethroughService: StrikethroughService<StrikethroughSchema>;

  public beforeInit(mode: EditorMode, schema: StrikethroughSchema) {
    this.strikethroughService = new StrikethroughService(schema.marks.strikethrough);
  }

  public afterInit(mode: EditorMode, editorView: EditorView) {
    this.editorView = editorView;
  }

  public getNativeEditorPlugins() {
    return [{ priority: DEFAULT_KEYMAP_INPUTRULE_PRIORITY, plugin: keymap(this.getKeyBindings()) }];
  }

  private getKeyBindings() {
    const toggle: ProsemirrorCommand = (...args) => this.strikethroughService.toggle(...args);
    return {
      'Mod-Shift-x': toggle,
      'Alt-Shift-5': toggle,
    };
  }
}
